import { RuleSet, css } from 'styled-components';

export const baseButton = css`
  border-radius: var(--rd-4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-body);
  font-size: var(--font-size-2);
  font-weight: var(--font-weight-base);
  text-align: center;
  letter-spacing: normal;
  border: none;
  padding: var(--space-2) var(--space-4);
  transition: all 0.5s;
  white-space: normal;

  &:active {
    border: 1px solid var(--black);
  }
`;

export const basePrimaryButton = css`
  ${baseButton};

  background-color: var(--clr-primary-1);
  border: 1px solid var(--clr-primary-1);
  color: var(--black);

  &:hover {
    background-color: var(--clr-primary-2);
    color: var(--black);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const basePrimaryTransparentButton = css`
  ${basePrimaryButton};

  background-color: transparent;
`;

export const baseSecondaryButton = css`
  ${baseButton};

  background-color: var(--white);
  border: 1px solid var(--clr-primary-1);
  color: var(--black);

  &:hover {
    background-color: var(--clr-primary-2);
    color: var(--black);
  }

  &:disabled {
    background-color: var(--clr-primary-1);
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background-color: var(--clr-primary-1);
    }
  }
`;

export const baseTertiaryButton = css`
  ${baseButton};

  background-color: var(--clr-primary-2);
  border: 1px solid var(--clr-primary-2);
  color: var(--black);

  &:hover {
    background-color: var(--clr-primary-1);
    color: var(--black);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const baseTransparentButton = css`
  ${baseButton};

  background-color: transparent;
  border: 1px solid var(--white);
  color: var(--black);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const baseTransparentBorderedButton = css`
  ${baseButton};

  background-color: transparent;
  border: 1px solid var(--clr-grey-1);
  color: var(--black);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const baseTransparentBorderedLightButton = css`
  ${baseButton};

  background-color: transparent;
  border: 1px solid var(--clr-tertiary-2);
  color: var(--black);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const baseClearButton = css`
  background: none;
  border: none;
  appearance: none;
  cursor: pointer;
`;
interface IBase {
  primary: RuleSet;
  secondary: RuleSet;
  tertiary: RuleSet;
  transparent: RuleSet;
  'transparent-bordered': RuleSet;
  'transparent-bordered-light': RuleSet;
  clear: RuleSet;
  link: RuleSet;
}

export const base: IBase = {
  primary: basePrimaryButton,
  secondary: baseSecondaryButton,
  tertiary: baseTertiaryButton,
  transparent: baseTransparentButton,
  'transparent-bordered': baseTransparentBorderedButton,
  'transparent-bordered-light': baseTransparentBorderedLightButton,
  clear: baseClearButton,
  link: baseClearButton,
};
